import { createSlice } from "@reduxjs/toolkit";

// Retrieve the initial state from localStorage
const initialState = {
  isFunMode: JSON.parse(localStorage.getItem('isFunMode')) || false,
};

const funModeSlice = createSlice({
  name: "funMode",
  initialState,
  reducers: {
    toggleFunMode: (state) => {
      state.isFunMode = !state.isFunMode;
      // Save updated state to localStorage
      localStorage.setItem('isFunMode', JSON.stringify(state.isFunMode));
    },
  },
});

export const { toggleFunMode } = funModeSlice.actions;
export default funModeSlice.reducer;
